import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../../components/table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useModal} from "../../../context/ModalContext";
import {useUser} from "../../../context/UserContext";
import ResultView from "../../../components/ResultView";
import HecRasHelper from "../../../helpers/HecRasHelper";

export function B20({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    const {openModal} = useModal()

    switch (row.error_id) {
        case MessageCodes.Internal.FLWSEL01.error_id: {
            const cs_list = Array.from(new Set(row?.data?.map(x => x.cross_section)))

            return (
                <>
                    <ResultText>
                        The WSEL of the following profiles are higher than the left and/or right end elevation of the {cs_list?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>Cross Section</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Profile</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                cs_list?.map(cs => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={cs} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>
                                            {row?.data?.filter(x => x.cross_section === cs).map(x => `${x.profile} (${x.side || 'L'})`).join(', ')}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}